import { memo, useEffect, useMemo, useState } from 'react';
import LoginQR from './LoginQR';
import { Container, Row, Col, NavDropdown } from 'react-bootstrap';
import { BzTabsContainer, BzTabsContent, BzInputText, BzButton } from '../../components';
import { useSelector } from 'react-redux';
//PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
import { API_ERRORS, API_RESPONSE_STATUS, APP_INFO_PARAMS, LOCAL_STORAGE_KEYS, LOGIN_CONSTANTS, LOGIN_ERROR_MSG } from '../../utils/global_variables';
import { getAppInfoData, handleKeyDownOnDiv,setStorageWithMultiTabCheckWithoutEncryption} from '../../utils/global_functions';
//PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End


const FormBody = ({ loginTab, text, showErrorBorder, spinner, objUserCredentials, showPassword, setShowPassword, route, handleSignup, handleTakeMeToSelect, bLoginButton, handleUserIdPasswordOnChange, objLoginSession, handleLogin, handleMpinPassword, handleShow, handleForgotUserId }) => {

  const brokerInformation = useSelector(state => state?.appInfo?.brokerInformation);
  const appInfo = useSelector(state => state.appInfo.appInfo);
  // BT-95890 -Mahesh S -  first time user login - code added for auth service down - start
  const authServiceDown = useSelector(state => state?.auth?.authServiceDown);
  // BT-95890 -Mahesh S -  first time user login - code added for auth service down - end

  const [eKYCInfo, setEKYCInfo] = useState(null);
  const [eKYCText, setEKYCText] = useState('');

  //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
  const nGuestTrialDays = useMemo(() => {
    return getAppInfoData(APP_INFO_PARAMS.APP_GUEST_MODE_TRIAL_DAYS);
  }, [appInfo]);
  //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End

  useEffect(() => {
    if (appInfo?.length) {
      const data = getAppInfoData(APP_INFO_PARAMS.APP_EKYC_INFO);
      if (objLoginSession?.errors === API_ERRORS.ECODE_ACC_SUSPENDED) {
        if (data?.reekycurl) {
          setEKYCInfo(data);
        }
        else { setEKYCInfo(null); }
        if (data?.ekyctext) {
          setEKYCText(data?.ekyctext);
        } else { setEKYCText(''); }
      }
      else {
        if (data?.ekycurl) {
          setEKYCInfo(data);
        }
        else { setEKYCInfo(null); }
        if (data?.ekyctext) {
          setEKYCText(data?.ekyctext);
        } else { setEKYCText(''); }
      }
    }
  }, [appInfo, objLoginSession]);
  // {/* Mahesh S : 27-11-2023 : BT-95890 first time login – to show guest flag  – Start */ }
  const isGuestAllowed = getAppInfoData(APP_INFO_PARAMS.APP_GUEST_MODE);
  const nCMOTMode = getAppInfoData(APP_INFO_PARAMS.APP_CMOT_MODE);
  const [isGuestFlagExist, setIsGuestFlagExist] = useState(false);
  useEffect(() => {
    if (nCMOTMode === 2 && isGuestAllowed !== undefined && isGuestAllowed.toString().trim().toUpperCase() === "TRUE") {
      setIsGuestFlagExist(true);
    }
  }, [nCMOTMode, isGuestAllowed]);
  {/* Mahesh S : 27-11-2023 : BT-95890 first time login – to show guest flag  – End */ }

  useEffect(() => {
    if (localStorage.getItem(LOCAL_STORAGE_KEYS.GUEST_USER) !== undefined) {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.GUEST_USER);
    }
  }, []);



  const handleBlur = (e) => {
    if (e.target.value !== undefined && e.target.value !== null && e.target.value !== '') {
       if(localStorage.getItem('MULTI_TAB') == 'true' ) {
           sessionStorage.setItem('ACTIVE_USER', e.target.value.toUpperCase());
       }else if(localStorage.getItem('MULTI_TAB') == 'false' ){
            localStorage.setItem('ACTIVE_USER', e.target.value.toUpperCase());
       }
    }
  };

  const handleRedirect = () => {
    if (eKYCInfo) {
      let url = objLoginSession?.errors === API_ERRORS.ECODE_ACC_SUSPENDED ? eKYCInfo?.reekycurl : eKYCInfo?.ekycurl
      window.open(url, '_blank');
    } else {
      handleShow()
    }
  }

  return (
    <>
      <Container fluid className='p-0'>
        <BzTabsContainer>
          <BzTabsContent isActive={loginTab == 'user_id'} showDefault tabKey='user_id'>
            <div className='login-content p-1'>
              <form autoComplete='off' onSubmit={(e) => e.preventDefault()}>
                <Row className='g-0 mb-2'>
                  <Col>
                    <div className={`input-group ${objLoginSession?.errors === API_ERRORS.ECODE_REQ_BODY_VALIDATIONS ? 'error' : ''}`}>
                      <BzInputText autoComplete='off' name='user_id' value={objUserCredentials.user_id ? objUserCredentials.user_id : ''} type='text' maxLength={LOGIN_CONSTANTS.LOGIN_USERID_LENGTH} data-testid='login-userid-input' placeholder='User ID' onChange={(e) => handleUserIdPasswordOnChange(e)} disabled={spinner} className={`p-0' autoFocus ${objUserCredentials.user_id ? 'text-uppercase' : ''}`} autoFocus onBlur={handleBlur} />
                    </div>
                    {text ?
                      <div className='default-msg'>We have retrieved above user ID under your name</div>
                      : null
                    }
                  </Col>
                </Row>

                <Row className='g-0 mb-2'>
                  <Col>
                    <div className={`input-group position-relative ${showErrorBorder ? 'error' : ''}  `}>
                      <BzInputText data-testid='login-password-input' autoComplete='off' name='user_password' value={objUserCredentials.user_password ? objUserCredentials.user_password : ''} type={`${showPassword ? 'text' : 'password'}`} placeholder='Password' maxLength={LOGIN_CONSTANTS.LOGIN_PASSWORD_MAX_LENGTH} onChange={(e) => handleUserIdPasswordOnChange(e)} disabled={spinner} className='pe-5' />
                      <div data-testid={`first-login-password-${showPassword ? 'visible' : 'hidden'}-icon`} onClick={() => { setShowPassword(curr => !curr); }} className={`icon-20 ${showPassword ? 'icon-eye' : 'icon-eyeslash'} icon-grey login-icon-position`}></div>
                    </div>
                  </Col>
                </Row>

                {authServiceDown ?
                  <Row className='g-0 mb-2'>
                    <Col>
                      <div data-testid={"is-auth-down"} className='error-msg'>{LOGIN_ERROR_MSG.AUTH_SERVICE_DOWN}</div>
                    </Col>
                  </Row>
                  : null
                }
                {(objLoginSession && objLoginSession?.status === API_RESPONSE_STATUS.ERROR && objLoginSession?.errors !== API_ERRORS.ECODE_PWD_EXPIRED && !authServiceDown) &&
                  <Row className='g-0 mb-2'>
                    <Col>
                      <div className='error-msg' data-testid="invalid-or-wrong-credentials-error">{objLoginSession?.errors === API_ERRORS.ECODE_REQ_BODY_VALIDATIONS ? 'Incorrect User Id or Password.' : objLoginSession.message}</div>
                    </Col>
                  </Row>
                }
                {(objLoginSession?.code === API_ERRORS.ECODE_NETWORK_ERROR) &&
                  <Row className='g-0 mb-2'>
                    <Col>
                      <div className='error-msg'>{LOGIN_ERROR_MSG.NETWORK_ERROR}</div>
                    </Col>
                  </Row>
                }
                <Row className='g-0 mb-3'>
                  <Col>
                    <div className='font-regular font-size3 color-subtext float-start'>Take Me To</div>
                    <NavDropdown data-testid='first-login-landing-dropdown' className='font-medium font-size3 color-primary text-capitalize ms-2 float-start' title={route} onSelect={handleTakeMeToSelect}>
                      <NavDropdown.Item size="sm" eventKey="dashboard" data-testid="first-login-dropdown-dashboard-item">Dashboard</NavDropdown.Item>
                      <NavDropdown.Item size="sm" eventKey="watchlist" data-testid="first-login-dropdown-watchlist-item">Watchlist</NavDropdown.Item>
                      <NavDropdown.Item size="sm" eventKey="portfolio" data-testid="first-login-dropdown-portfolio-item">Portfolio</NavDropdown.Item>
                      <NavDropdown.Item size="sm" eventKey="orders" data-testid="first-login-dropdown-orders-item">Orders</NavDropdown.Item>
                    </NavDropdown>
                  </Col>
                </Row>
                <Row className='g-0 mb-3'>
                  <Col>
                    <BzButton data-testid='id-password-verify-button' onClick={handleLogin} className='btn btn-md btn-block btn-primary' type='submit' disabled={!bLoginButton}>Verify</BzButton>
                  </Col>
                </Row>
              </form>

              <Row className='g-0 mb-4'>
                <Col className='d-flex justify-content-start align-self-center'>
                  <a data-testid='login-forgot-userid-link' className='font-medium font-size2 color-link focus' disabled={spinner} href='#' onKeyDown={handleKeyDownOnDiv} onClick={handleForgotUserId}>Forgot User ID?</a>
                </Col>
                <Col className='d-flex justify-content-end align-self-center'>
                  <a data-testid='login-forgot-password-link' className='font-medium font-size2 color-link focus' disabled={spinner} href='#' onKeyDown={handleKeyDownOnDiv} onClick={() => handleMpinPassword('password')}>Forgot password?</a>
                </Col>
              </Row>
              {
                eKYCInfo ? <div className='signup-box'>
                  <Row className='g-0 mb-2'>
                    <Col className='d-flex justify-content-start'>
                      <div className='font-medium font-size4 signup-box-title'>Amazing benefits with new account</div>
                    </Col>
                  </Row>
                  <Row className='g-0 mb-2'>
                    <Col className='d-flex justify-content-start'>
                      <div className='font-regular font-size2 signup-box-subtitle text-wrap'>Get free account opening, trade ideas, dedicated relationship manager &amp; margin benefit!</div>
                    </Col>
                  </Row>
                  <Row className='g-0'>
                    <Col className='d-grid'>
                      <BzButton data-testid='login-signup-button' className='btn btn-md signup-box-btn'>
                        <div className='d-flex justify-content-center align-items-center' disabled={spinner} onClick={handleRedirect}>
                          <span className='font-medium font-size3 textcolor-signupbox'>Open an Account</span>
                          <div className='icon-16 icon-forward-arrow iconcolor-signupbox ms-2'></div>
                        </div>
                      </BzButton>
                    </Col>
                  </Row>
                </div> : null
              }
              {isGuestFlagExist && (
                <>
                  {eKYCInfo ? <Row className="g-0 my-3">
                    <Col>
                      <div className="fancyline">
                        <span className="font-medium font-size1 color-subtext">OR</span>
                      </div>
                    </Col>
                  </Row> : null}
                  <Row className="g-0 mb-2">
                    <Col className="d-flex justify-content-start align-self-center">
                      <div data-testid="ekycinfo" className="font-regular font-size2 color-subtext">
                        Try out the App
                        <a
                          data-testid="guest-signup-button"
                          onClick={handleSignup}
                          target="_blank"
                          className="font-medium font-size2 focus ms-1"
                          disabled={spinner}
                        >
                          Register for free guest access
                        </a>
                      </div>
                    </Col>
                  </Row>
                </>
              )}

            </div>
          </BzTabsContent>
          <BzTabsContent isActive={loginTab == 'qr_code'} tabKey='qr_code' >
            {loginTab == 'qr_code' ? <LoginQR /> : null}
          </BzTabsContent>
        </BzTabsContainer>
      </Container>
    </>
  );
};
export default memo(FormBody);